import { createSlice } from '@reduxjs/toolkit';
import { createExam, getListExams } from './examThunk';
import { RootState } from '~/utils/redux/store';
import { IExam } from '~/utils/interface/exam';

interface ExamState {
  exams: IExam[];
  isRefreshListExam: boolean;
  isLoadingCreateExam: boolean;
}

const initialState: ExamState = {
  exams: [],
  isLoadingCreateExam: false,
  isRefreshListExam: false,
};

const examSlice = createSlice({
  name: 'examSlice',
  initialState,
  reducers: {
    setRefreshList(state, action) {
      state.exams = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListExams.pending, (state) => {})
      .addCase(getListExams.fulfilled, (state, action) => {
        state.exams = action.payload.responses;
      })
      .addCase(getListExams.rejected, (state) => {});

    // create exam
    builder
      .addCase(createExam.pending, (state) => {
        state.isLoadingCreateExam = true;
      })
      .addCase(createExam.fulfilled, (state, action) => {
        state.isRefreshListExam = true;
        state.isLoadingCreateExam = false;
      })
      .addCase(createExam.rejected, (state) => {
        state.isLoadingCreateExam = false;
      });
  },
});

// Action
export const examAction = examSlice.actions;

// Selectors
export const selectExams = (state: RootState) => state.examState.exams;

// Reducer
const examReducer = examSlice.reducer;
export default examReducer;
